import { Divider, Select, Space } from "antd";
import 'moment-timezone';
import React, { useState } from 'react';
import Loading from "../Loading";
import Toastr from 'toastr';
import SessionManager from "../../routes/SessionManager";
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function StrobeModal(props) {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');

    const [devices_selected, setDevicesSelected] = useState([]);
    const [devices] = useState(props.devices || []);

    const publishStrobe = () => {

        let locations_selected = {};
        for (let d of devices_selected)
            locations_selected[d.split('@')[1]] = 1;

        let data = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            locations: Object.keys(locations_selected)
        };

        CommonUtils.ajax(
            {
                url: API.AXIS_CAMERA.TURN_ON_STROBE,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    Toastr.success("Strobe played successfully !");
                    setDevicesSelected([]);
                } else {
                    Toastr.error("Error occurred ... Please try again !");
                }
            },
            (res) => {
                Toastr.error("Error occurred ... Please try again !");
            });
    }

    const isFormValid = () => {
        if (devices_selected.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    return (
        <React.Fragment>
            <div className="modal-header py-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>
            <div className="modal-footer bg-light" style={{ height: "2rem" }}>
                <label className="text-primary" style={{ position: "absolute", left: "1rem" }}>Site: {user && user.site_selected && user.site_selected.site_name}</label>
            </div>
            {!devices ? <div className="p-5"><Loading>Loading ...</Loading></div> :
                devices.length === 0 ? <center className="p-5">No Strobe devices found.</center> :
                    <>
                        <div className='p-3 align-left'>
                            <div className="row">
                                <div className="col-md-12 pb-5">
                                    <table width="100%" style={{ textAlign: "left" }}>
                                        <tbody>
                                            <tr>
                                                <td>Zones:</td>
                                                <td>
                                                    <Select
                                                        mode="multiple"
                                                        value={devices_selected}
                                                        style={{ width: '200px', fontSize: '13px' }}
                                                        onChange={(v) => setDevicesSelected(v)}
                                                        options={devices}
                                                        dropdownMatchSelectWidth={false}
                                                        placeholder="Choose Zones"
                                                        dropdownRender={(menu) => (
                                                            <>
                                                                {menu}
                                                                <Divider style={{ margin: '8px 0' }} />
                                                                <Space style={{ padding: '0px 4px' }}>
                                                                    <button className="btn btn-sm btn-success" onClick={() => setDevicesSelected(devices.map(x => x.value))}>
                                                                        All Zones
                                                                    </button>
                                                                </Space>
                                                            </>
                                                        )}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer bg-light" style={{ height: "3rem" }}>
                            <button disabled={!isFormValid()} className="btn btn-xs btn-primary" onClick={() => publishStrobe()}>Submit</button>
                        </div>
                    </>
            }
        </React.Fragment>
    );
}

export default StrobeModal;